import { Check, ShieldCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";

const WE_ORGANIZE = [
    "Oferte și disponibilitate de la furnizori verificați",
    "Programări, acces, etaj și lift, ore și persoane de contact",
    "Buget, dimensiunile casei și sincronizarea livrărilor",
    "Comunicarea cu familia, cu acordul beneficiarului",
];

const PARTNERS_HANDLE = [
    "Ambulanța privată — tipul transportului, echipajul și siguranța",
    "Echipamentele medicale — montaj, instruire, service, înlocuire",
    "Fizioterapia — evaluarea, indicațiile și tratamentul",
    "Îngrijirea personală — planul de îngrijire și prestația efectivă",
    "Adaptările locuinței — soluția tehnică, execuția și garanția",
];

export const Partners = () => (
    <section id="parteneri" data-testid="partners-section" className="py-16 sm:py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeading
                testid="partners-heading"
                eyebrow="Clar și cinstit"
                title="Ce facem noi și ce fac partenerii licențiați"
                text="Nu oferim servicii medicale. Noi organizăm și coordonăm; îngrijirea reglementată aparține furnizorilor acreditați și licențiați, care contractează și facturează direct clientului."
            />

            <div className="mt-12 grid grid-cols-1 gap-5 sm:gap-6 lg:grid-cols-2">
                <Reveal>
                    <div className="h-full rounded-3xl bg-teal p-7 sm:p-10 text-cream" data-testid="partners-we-organize">
                        <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-cream/10">
                            <Check className="h-6 w-6" />
                        </span>
                        <h3 className="mt-5 font-serif text-2xl sm:text-3xl font-semibold">Noi organizăm</h3>
                        <ul className="mt-6 flex flex-col gap-4">
                            {WE_ORGANIZE.map((item) => (
                                <li key={item} className="flex items-start gap-3 text-sm sm:text-base text-cream/85 leading-relaxed">
                                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-coral" />
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </Reveal>
                <Reveal delay={0.1}>
                    <div className="h-full rounded-3xl bg-creamlight p-7 sm:p-10 ring-1 ring-coral/25" data-testid="partners-licensed">
                        <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-coral/10 text-coral">
                            <ShieldCheck className="h-6 w-6" />
                        </span>
                        <h3 className="mt-5 font-serif text-2xl sm:text-3xl font-semibold text-charcoal">Partenerii răspund de</h3>
                        <ul className="mt-6 flex flex-col gap-4">
                            {PARTNERS_HANDLE.map((item) => (
                                <li key={item} className="flex items-start gap-3 text-sm sm:text-base text-charcoal/75 leading-relaxed">
                                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-teal" />
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </Reveal>
            </div>

            <Reveal delay={0.15}>
                <p className="mt-8 rounded-2xl bg-sand/60 px-6 py-4 text-sm text-charcoal/65 leading-relaxed ring-1 ring-teal/10" data-testid="partners-note">
                    Fiecare furnizor contractează și facturează direct clientului. Ține(te) de noi facturează doar organizarea proprie — recomandăm după potrivire, preț și disponibilitate.
                </p>
            </Reveal>
        </div>
    </section>
);
